import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IAppState } from '../state/app.state';
import { WarehouseService } from 'src/app/Services/WareHouse/warehouse.service';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
    GetAllPOs, EPOActions, EditPO, AddReceiveMaterial,
    GetAllReceivedLOTs, EditReceivedLOTs, GetPONumber, AddPO, GetReceiveMaterialCode,
    InActivatePO, GetPodetailsById, GetAllVehicleCondition, StatusMoveToComplete,
    GetPOsByStatusId, GetCompletePO, GetPOsByAgentManuId
} from '../actions/po.action';
import { PoService } from 'src/app/Services/PO/po.service';

@Injectable()
export class POEffects {
    constructor(private actions$: Actions,
        private store: Store<IAppState>,
        private poService: PoService
    ) { }
    //purchase orders


    getPOnumber$ = createEffect(() => this.actions$.pipe(
        ofType<GetPONumber>(EPOActions.GetPONumber),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.getPONumber(payload)
            .pipe(map((result: any) => ({ type: '[PurchaseOrders] Set PO InternalCode Success', payload: result })),
                catchError((err) => of({ type: '[PurchaseOrders] Set PO InternalCode Error', payload: err, from: 'getPOnumber' }))
            )
        )
    ));


    getAllPOs$ = createEffect(() =>this.actions$.pipe(
        ofType<GetAllPOs>(EPOActions.GetAllPOs),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.getAllPOs(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get All POs Success', payload: result })),
                catchError((err) => of({ type: '[] Get All POs Error', payload: err, from: 'getAllPOs' }))
            )
        )
    ));


    getPosByStatusId$ = createEffect(() =>this.actions$.pipe(
        ofType<GetPOsByStatusId>(EPOActions.GetPOsByStatusId),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.getPosByStatusId(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get POs By StatusId Success', payload: result })),
                catchError((err) => of({ type: '[] Get POs By StatusId Error', payload: err, from: 'getPOsByStatusId' }))
            )
        )
    ));


    addPO$ = createEffect(() =>this.actions$.pipe(
        ofType<AddPO>(EPOActions.AddPO),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.addPO(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Add PO Success', payload: result })),
                catchError((err) => of({ type: '[] Get Add PO Error', payload: err, from: 'AddPO' }))
            )
        )
    ));


    editPO$ = createEffect(() => this.actions$.pipe(
        ofType<EditPO>(EPOActions.EditPO),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.editPOs(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Edit PO Success', payload: result })),
                catchError((err) => of({ type: '[] Get Edit PO Error', payload: err, from: 'EditPO' }))
            )
        )
    ));

    getPOdetailsById$ = createEffect(() => this.actions$.pipe(
        ofType<GetPodetailsById>(EPOActions.GetPodetailsById),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.getPOdetailsById(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get PO Details By Id Success', payload: result })),
                catchError((err) => of({ type: '[] Get PO Details By Id Error', payload: err, from: 'getPodetailsById' }))
            )
        )
    ));



    getReceiveMatCode$ = createEffect(() => this.actions$.pipe(
        ofType<GetReceiveMaterialCode>(EPOActions.GetReceiveMaterialCode),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.getReceiveMaterialCode(payload)
            .pipe(map((result: any) => ({ type: '[ReceiveMaterial] Set ReceiveMaterial InternalCode Success', payload: result })),
                catchError((err) => of({ type: '[ReceiveMaterial] Set ReceiveMaterial InternalCode Error', payload: err, from: 'getRMCode' }))
            )
        )

    ));


    addReceiveMat$ = createEffect(() => this.actions$.pipe(
        ofType<AddReceiveMaterial>(EPOActions.AddReceiveMaterial),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.addReceiveMaterial(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Add Receive material Success', payload: result })),
                catchError((err) => of({ type: '[] Add Receive material Error', payload: err, from: 'addReceiveMaterial' }))
            )
        )

    ));


    getAllReceivedLOts$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllReceivedLOTs>(EPOActions.GetAllReceivedLOTs),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.getAllReceivedLOTs(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get All Receive Lots Success', payload: result })),
                catchError((err) => of({ type: '[] Get All Receive Lots Error', payload: err, from: 'getAllReceivedLOts' }))
            )
        )

    ));

    editReceivedLOTs$ = createEffect(() => this.actions$.pipe(
        ofType<EditReceivedLOTs>(EPOActions.EditReceivedLOTs),
        map(action => action.payload),
        mergeMap((payload: any) => this.poService.editReceivedLOTs(payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get Edit Receive Lots Success', payload: result })),
                catchError((err) => of({ type: '[] Get Edit Receive Lots Error', payload: err, from: 'EditReceivedLots' }))
            )
        )

    ));


    getAllVehicleCondition$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllVehicleCondition>(EPOActions.GetAllVehicleCondition),
        map(action => action),
        mergeMap((payload: any) => this.poService.getAllVehicleCondition()
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get Vehicle Condition Success', payload: result })),
                catchError((err) => of({ type: '[] Get Vehicle Condition Error', payload: err, from: 'getAllVehicleCondition' }))
            )
        )

    ));

    StatusMoveToComplete$ = createEffect(() => this.actions$.pipe(
        ofType<StatusMoveToComplete>(EPOActions.StatusMoveToComplete),
        map(action => action),
        mergeMap((action) => this.poService.statusMoveToComplete(action.payload)
            .pipe(map((result: any) => ({ type: '[POMaterials] Status move to Complete Success', payload: result })),
                catchError((err) => of({ type: '[] Status move to Complete Error', payload: err, from: 'statusMoveToComplete' }))
            )
        )
    ));


    inActivatePO$ = createEffect(() => this.actions$.pipe(
        ofType<InActivatePO>(EPOActions.InActivatePO),
        map(action => action),
        mergeMap((action) => this.poService.inActivatePO(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get InActivate PO Success', payload: result })),
                catchError((err) => of({ type: '[] Get InActivate PO Error', payload: err, from: 'InActivatePO' }))
            )
        )
    ));


    getCompletePO$ = createEffect(() => this.actions$.pipe(
        ofType<GetCompletePO>(EPOActions.GetCompletePO),
        map(action => action),
        mergeMap((action) => this.poService.getCompletePO(action.payload, action.param)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get Complete PO Success', payload: result })),
                catchError((err) => of({ type: '[] Get Complete PO Error', payload: err, from: 'getCompletePO' }))
            )
        )
    ));

    getPosByAgentManuId$ = createEffect(() => this.actions$.pipe(
        ofType<GetPOsByAgentManuId>(EPOActions.GetPOsByAgentManuId),
        map(action => action),
        mergeMap((action) => this.poService.getPosByAgentManuId(action.payload)
            .pipe(map((result: any) => ({ type: '[purchaseOrders] Get PO By AgentManu Id Success', payload: result })),
                catchError((err) => of({ type: '[purchaseOrders] Get PO By AgentManu Id Error', payload: err, from: 'getPosByAgentManuId' }))
            )
        )
    ));

}
